// extracted by mini-css-extract-plugin
export default {"wrapper":"_911374de","hidden":"_44bbda47"};